import { IDropdownOption } from "components/atoms";

export const COURSE_TYPE = {
  PRACTICE: 1,
  THEORY: 2,
  PRACTICE_THEORY: 3,
} as const;
export const COURSE_TYPE_NAMES = {
  PRACTICE: "Praktyka",
  THEORY: "Teoria",
  PRACTICE_THEORY: "Teoria/Praktyka",
} as const;
export const COURSE_TYPEID_NAMES = {
  [COURSE_TYPE.PRACTICE]: COURSE_TYPE_NAMES.PRACTICE,
  [COURSE_TYPE.THEORY]: COURSE_TYPE_NAMES.THEORY,
  [COURSE_TYPE.PRACTICE_THEORY]: COURSE_TYPE_NAMES.PRACTICE_THEORY,
} as const;
export const COURSE_SCHEDULE_TYPE_OPTIONS: IDropdownOption[] = [
  { label: COURSE_TYPE_NAMES.PRACTICE, value: COURSE_TYPE.PRACTICE },
  { label: COURSE_TYPE_NAMES.THEORY, value: COURSE_TYPE.THEORY },
  { label: COURSE_TYPE_NAMES.PRACTICE_THEORY, value: COURSE_TYPE.PRACTICE_THEORY },
];

export const COURSE_PLACE_TYPE = {
  ONLINE: 1,
  ONSITE: 2,
  USER_CHOICE: 3,
};

export const COURSE_PLACE_TYPE_OPTIONS = [
  { label: "Online", value: COURSE_PLACE_TYPE.ONLINE },
  { label: "Stacjonarnie", value: COURSE_PLACE_TYPE.ONSITE },
  { label: "Wybór użytkownika", value: COURSE_PLACE_TYPE.USER_CHOICE },
];
